export const iconFontAwesomeHumanitarianSquareNfi = (
	<i className="fa-solid fa-square-nfi"></i>
);
